import React from "react";
import { FaTimes } from "react-icons/fa";

function NotificationFilters({
  showFilter,
  filters,
  onFilterChange,
  onApplyFilters,
  onResetFilters,
  onToggleFilter,
}) {
  if (!showFilter) return null;

  return (
    <div className="notification-filter-overlay">
      <div className="notification-filter-modal">
        {/* Header */}
        <div className="notif-filter-header">
          <h5>
            <i className="fas fa-filter me-2"></i>
            Filter Notifications
          </h5>
          <button
            type="button"
            className="filter-close-btn"
            onClick={onToggleFilter}
          >
            <FaTimes />
          </button>
        </div>

        {/* Body */}
        <div className="notif-filter-body">
          <div className="notif-filter-grid">
            {/* Type */}
            {/* <div className="notif-filter-field">
              <label className="form-label">Type</label>
              <select
                name="type"
                className="form-control custumform"
                value={filters.type || ""}
                onChange={onFilterChange}
              >
                <option value="">All Types</option>
                <option value="lead">Lead</option>
                <option value="payment">Payment</option>
                <option value="reminder">Reminder</option>
                <option value="system">System</option>
              </select>
            </div> */}

            {/* Status */}
            <div className="notif-filter-field">
              <label className="form-label">Status</label>
              <select
                name="unread_only"
                className="form-control custumform"
                value={filters.unread_only ?? ""}
                onChange={onFilterChange}
              >
                <option value="">All</option>
                <option value="1">Unread Only</option>
  <option value="0">Read Only</option>
              </select>
            </div>

            {/* From Date */}
            <div className="notif-filter-field">
              <label className="form-label">From Date</label>
              <input
                type="date"
                name="from_date"
                className="form-control custumform"
                value={filters.from_date || ""}
                onChange={onFilterChange}
              />
            </div>

            {/* To Date */}
            <div className="notif-filter-field">
              <label className="form-label">To Date</label>
              <input
                type="date"
                name="to_date"
                className="form-control custumform"
                value={filters.to_date || ""}
                onChange={onFilterChange}
              />
            </div>
          </div>
        </div>

        {/* Footer */}
        <div className="notif-filter-footer">
          <button
            type="button"
            className="lead-btn"
            onClick={onResetFilters}
          >
            Reset
          </button>
          <button
            type="button"
            className="lead-btn btn-all active"
            onClick={onApplyFilters}
          >
            Apply Filters
          </button>
        </div>
      </div>
    </div>
  );
}

export default NotificationFilters;